import type { Variant } from './gameTypes.js';
import { VARIANTS } from './gameTypes.js';

/** Stored grids and their runs remain addressable after catalogue revisions. */
const RETIRED_JUMP_TRACKS = [
  'on-and-on', 'sky-high', 'heroes', 'cradles', 'my-heart', 'invincible',
  'hope', 'adventure', 'blank', 'diamond', 'hollah', 'nekozilla',
] as const;

export const RETIRED_JUMP_SLUGS: readonly string[] = RETIRED_JUMP_TRACKS.flatMap((slug) =>
  VARIANTS.map((variant) => variant === 'normal' ? slug : `${slug}-${variant}`),
);

export function isRetiredBuiltinMap(mode: string, slug: string): boolean {
  return mode === 'jump' && RETIRED_JUMP_SLUGS.includes(slug);
}

export function jumpFlowSlug(audioSlug: string, variant: Variant): string {
  return `${audioSlug}-flow${variant === 'normal' ? '' : `-${variant}`}`;
}
